//
// Copyright (c) 2011-2017 by Curalate, Inc.
//
// This file is responsible for managing URL parameters passed in via URL/Referrer query params

import { sessionFetch } from 'app/utils/sessionFetch';

(function() {
    crl8.userSessionPromise.then(function(session) {
        /**
         * Returns the proper separator for the next query param in a URL.
         */
        var getQuerySeparatorForUrl = function (url) {
            return url.indexOf('?') === -1 ? '?' : '&';
        };
        /**
         * Adds a query parameter to a url
         */
        var addUrlParam = function(url, name, value) {
            return url + getQuerySeparatorForUrl(url) + name + '=' + value;
        };


        /**
         * Adds, updates, and removes query parameters from the current URL based on a map of parameter names to values
         * @param params        Map of parameter names to values.
         *                       - If a parameter value is undefined, any existing parameter with the name will be removed.
         * @returns {string}    New URL based on the current page URL with parameters replaced.
         */
        var getNewUrlWithParams = function(params) {
            var search = window.location.search;
            var paramNames = Object.keys(params);

            paramNames.forEach(function(name) {
                search = search.replace(new RegExp("[?&]" + name + "=[^&]*"), ''); // Remove each parameter from url
            });

            search = search.replace(/^&/, '?'); // If we removed the first parameter, make sure we put the ? back in.

            paramNames.forEach(function(name) {
                if (params[name] !== undefined) {
                    search = addUrlParam(search, name, params[name]);
                }
            });

            return window.location.origin + window.location.pathname + search + window.location.hash;
        };

        /**
         * Removes any clientId from the current page URL, and optionally adds a new clientId
         * @param clientId      ClientId to add to the URL, or <undefined> to add no clientId
         * @returns {string}    New URL based on the current page URL with clientId replaced.
         */
        var getnewUrlWithClientId = function(clientId) {
            return getNewUrlWithParams({
                "clientId": clientId
            });
        };

        var getDateRangeParameters = function() {
            var dateRange = crl8.session.dateRange,
                params = {
                    dateRange: undefined,
                    fromDate: undefined,
                    toDate: undefined
                },
                type = dateRange ? dateRange.type : undefined;

            if (type === 'C') {
                params.fromDate = dateRange.from.replace(/\//g, '-');
                params.toDate = dateRange.to.replace(/\//g, '-');
            } else if (!!type) {
                params.dateRange = type;
            }
            return params;
        };

        /**
         * Removes any date parameters from the current page URL, and optionally adds new ones
         * @returns {string}    New URL based on the current page URL with date parameters replaced.
         */
        var getNewUrlWithDateParameters = function() {
            return getNewUrlWithParams(getDateRangeParameters());
        };

        // URL Change spam can lock up the browser badly. If we make at least one URL change every second for 3 seconds, we're probably
        // locking the browser. This safety check/lock functionality tries to prevent locking the browser.
        var safetyCheck = function(lock) {
            var last3 = (lock.last3 || []).slice(-3);
            var nowSec = +new Date() / 1000 | 0;
            if (last3.slice(-1)[0] !== nowSec) {
                last3.push(nowSec);
                if (last3.length > 3) {
                    last3.shift();
                }
                lock.last3 = last3;
            }

            if (last3.length === 3 &&
                last3[1] === nowSec - 1 &&
                last3[0] === nowSec - 2) {
                // We've locked for the last 3 seconds straight.
                // Throw an exception to stop the chain and our logger will pick it up.
                throw new Error('Consistent param refreshes over the last 3 seconds. Noping out of refreshing parameters for ' + lock.name);
            }
            return true;
        };

        var sessionParamLock = {
            name: 'clientId'
        };
        var dateParamLock = {
            name: 'dateRange'
        };

        CURALATE.misc.getDateRangeParameters = getDateRangeParameters;
        // Updates the current page URL with a clientId override from the session vars, if available.
        CURALATE.misc.refreshSessionParams = function () {
            if (session.client && session.client.isClientIdOverrideActive && safetyCheck(sessionParamLock)) {
                // This will also remove any bogus clientId or groupId in the URL
                history.replaceState(history.state, undefined, getnewUrlWithClientId(session.client.id));
            }
        };

        // Updates the current page URL with a dateRange override from the session vars, if available.
        CURALATE.misc.refreshDateParams = function() {
            if (session.dateRange && session.dateRange.isOverrideActive && safetyCheck(dateParamLock)) {
                // This will also remove any bogus date range params in the URL
                history.replaceState(history.state, undefined, getNewUrlWithDateParameters(session.dateRange));
            }
        };

        CURALATE.misc.refreshSessionParams();
        CURALATE.misc.refreshDateParams();

        //Updates the serverside crl8.clntid cookie when loggen in from BV portal redirects dashobard with appended clientId in url params
        const sessionClientId = session.client.id;
        sessionFetch('/api/clients', {
        method: 'POST',
        body: JSON.stringify({ id: sessionClientId }),
        });

        if (session.client.isClientIdOverrideActive) {
            // We're in "clientId override mode."
            // Let's take over the brand/group selectors so that they only update the clientId override.

            var getSwitcherSetCallback = function () {
                return window.crl8.clientSwitcherSetClientCallback || angular.noop;
            };

            CURALATE.misc.Components.changeClient = function (clientId) {
                // Replace state and then navigate, to make sure the new ClientId is preserved through redirects
                // e.g. switch brand to a brand that doesn't have access to the current page
                getSwitcherSetCallback()();
                var url = getnewUrlWithClientId(clientId);
                history.replaceState(history.state, undefined, url);
                window.location.assign(url);
            };
            CURALATE.misc.Components.changeGroup = function (groupSelector) {
                // Replace state and then reload the page, to make sure the new ClientId is preserved through redirects
                // e.g. switch brand to a brand that doesn't have access to the current page
                getSwitcherSetCallback()();
                var url = getnewUrlWithClientId(
                    groupSelector.options[groupSelector.selectedIndex].dataset.defaultClient
                );
                history.replaceState(history.state, undefined, url);
                window.location.assign(url);
            };
        }
    });
})();
